{
	"answer": {
		"received": "Received on {{when}}",
		"title": "Answer of the student"
	},
	"card": {
		"application": "Application",
		"document": "Document",
		"download": "Download",
		"facts": "Data declared and threshold",
		"file_failed": "We could not open the document. Try again.",
		"no_files": "The application has no document to show.",
		"page": "Page",
		"page_hint": "The page you show is the one the outcome cites.",
		"protocol": "Protocol {{protocol}} · {{name}}",
		"relevant": "relevant"
	},
	"closed": {
		"by": "Recorded by",
		"by_at": "{{name}}, {{when}}",
		"evidence": "Proof",
		"evidence_expired": "Clarification ran out with no answer",
		"evidence_file": "{{file}}, page {{page}}",
		"resolution": "Outcome"
	},
	"closed_by": "by {{name}}",
	"code": {
		"cfu_below_min": "Credits below the minimum",
		"iseeu_above": "ISEEU above the threshold",
		"ispeu_above": "ISPEU above the threshold",
		"offsite_not_met": "Off-site condition not met"
	},
	"columns": {
		"code": "Kind",
		"declared": "Declared",
		"due": "Deadline",
		"name": "Surname and name",
		"protocol": "Prot.",
		"quotas": "Quotas concerned",
		"state": "State",
		"threshold": "Threshold of the call"
	},
	"counters": {
		"open": "To close"
	},
	"due": {
		"date": "{{date}} at 24:00",
		"none": "From the closing of the call",
		"soon": "Fewer than two working days left"
	},
	"empty": "No flag: the data declared meets the requirements of the call.",
	"empty_filtered": "No flag with these filters.",
	"facts": {
		"ceiling_q30": "Quota 30%: {{q30}}",
		"ceilings": "Quota 30%: {{q30}} · Quota 70%: {{q70}}",
		"credits_min_one": "At least {{count}} credit",
		"credits_min_other": "At least {{count}} credits",
		"credits_one": "{{count}} credit",
		"credits_other": "{{count}} credits",
		"not_given": "Not given",
		"off_site_required": "Off-site"
	},
	"filters": {
		"code": "Kind",
		"quota": "Quota",
		"state": "State"
	},
	"off_site": {
		"commuter": "Commuter",
		"in_site": "In town",
		"off_site": "Off-site"
	},
	"outcome": {
		"already_closed": "{{name}} already closed this flag.",
		"cause": "Cause",
		"cause_required": "Choose the cause.",
		"choose": "Choose",
		"clarification": "Ask for a clarification",
		"clarification_asked": "Clarification asked, answer by {{date}} at 24:00",
		"corrected": "Data corrected from the document",
		"not_met": "Confirmed, requirement not met",
		"page_cited": "Page cited: {{page}}.",
		"page_missing": "Show the page of the document that proves it.",
		"page_required": "Give the page of the document.",
		"question": "Question for the student",
		"question_hint": "From 10 to 2,000 characters. The student reads it in their area.",
		"question_length": "Write a question of 10 to 2,000 characters.",
		"saved": "Outcome recorded",
		"still_fails": "The value of the document changes the outcome of no quota: record «Confirmed, requirement not met».",
		"submit_clarification": "Send the request",
		"submit_corrected": "Record the correction",
		"submit_not_met": "Record",
		"title": "Outcome",
		"unchanged": "The value is the one declared.",
		"value": "Value of the document",
		"value_required": "Give the value of the document.",
		"waiting": "Waiting for the answer of the student: the outcome is recorded after the answer or once the term runs out."
	},
	"page_title": "Flags",
	"pec_reply": {
		"copied": "Text copied.",
		"copy": "Copy text",
		"hint": "The application came from a PEC: Unicasa sends no email to a PEC box. Send this text to the student from the PEC of the residence.",
		"title": "Text to send from the PEC of the residence"
	},
	"reviewing": "Being reviewed by {{name}}",
	"someone": "another manager",
	"state": {
		"awaiting_clarification": "Clarification asked",
		"clarification_expired": "Term ran out with no answer",
		"clarification_received": "Answer received",
		"open": "To verify",
		"resolved_confirmed": "Requirement not met",
		"resolved_corrected": "Data corrected"
	}
}
